import { Check } from "lucide-react";
import { PROFESSION_IDS, LEVEL_IDS, PROF_T } from "../content/professions";

export const LevelRows = ({ T, sel, levels, other, onLevel, disabled, testid = "prof-level" }) => (
  sel.length > 0 && (
    <div className="space-y-2" data-testid={`${testid}-rows`}>
      {sel.map((id) => (
        <div key={id} className="flex flex-wrap items-center gap-2 border-l-2 border-[#D4AF37]/50 pl-3">
          <span className="text-sm text-[#F2E3C6] w-44">{id === "other" ? other || T.names.other : T.names[id]}</span>
          {LEVEL_IDS.map((lv) => (
            <button type="button" key={lv} disabled={disabled} onClick={() => onLevel(id, lv)} data-testid={`${testid}-${id}-${lv}`}
              className={`px-3 py-1.5 text-xs border transition-colors disabled:opacity-50 ${levels[id] === lv ? "border-[#D4AF37] bg-[#D4AF37] text-black font-semibold" : "border-white/15 text-white/60 hover:border-[#D4AF37]/60"}`}>
              {T.levels[lv]}
            </button>
          ))}
        </div>
      ))}
    </div>
  )
);

export default function ProfessionPicker({ lang, f, setF, disabled, goldTooFew }) {
  const T = PROF_T[lang] || PROF_T.sk;
  const sel = f.professions || [];
  const levels = f.prof_levels || {};
  const toggle = (id) => setF((p) => ({ ...p, professions: sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id] }));
  const onLevel = (id, lv) => setF((p) => ({ ...p, prof_levels: { ...(p.prof_levels || {}), [id]: lv } }));
  return (
    <section className="space-y-5" data-testid="profession-picker">
      <p className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase">{T.title}</p>
      <div>
        <p className="text-xs tracking-[0.18em] uppercase text-white/40 mb-3">{T.pick} *</p>
        <div className="flex flex-wrap gap-2">
          {PROFESSION_IDS.map((id) => {
            const on = sel.includes(id);
            return (
              <button type="button" key={id} disabled={disabled} onClick={() => toggle(id)} data-testid={`profession-${id}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 text-sm border transition-colors disabled:opacity-50 ${on ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#F2E3C6]" : "border-white/15 text-white/60 hover:border-[#D4AF37]/50"}`}>
                {on && <Check size={13} className="text-[#D4AF37]" />} {T.names[id]}
              </button>
            );
          })}
        </div>
      </div>
      {sel.includes("other") && (
        <input value={f.profession_other || ""} disabled={disabled} onChange={(e) => setF((p) => ({ ...p, profession_other: e.target.value }))}
          placeholder={T.other} data-testid="profession-other" maxLength={120}
          className="w-full bg-transparent border-b border-white/20 py-2.5 text-white focus:outline-none focus:border-[#D4AF37] transition-colors" />
      )}
      <LevelRows T={T} sel={sel} levels={levels} other={f.profession_other} onLevel={onLevel} disabled={disabled} />
      <div className="max-w-xs">
        <label className="block text-xs tracking-[0.18em] uppercase text-white/40 mb-2">{T.years} *</label>
        <input type="number" min={0} max={60} required disabled={disabled} value={f.years_practice ?? ""} data-testid="years-practice"
          onChange={(e) => setF((p) => ({ ...p, years_practice: e.target.value === "" ? null : Math.max(0, Math.min(60, parseInt(e.target.value, 10) || 0)) }))}
          className="w-full bg-transparent border-b border-white/20 py-2.5 text-white focus:outline-none focus:border-[#D4AF37] transition-colors" />
        <p className="text-white/35 text-xs mt-1.5">{T.yearsHint}</p>
      </div>
      {goldTooFew && <p className="text-red-300 text-sm border border-red-400/30 bg-red-500/5 px-4 py-3" data-testid="years-gold-warning">{T.gold}</p>}
    </section>
  );
}
